import React from 'react';
import { SectionTitle } from './SectionTitle';
import { readyItems } from '../data/salesCopy';
export function ReadySection() {
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-174" data-mp="e7lgi3ilso4e">
      <div className="mx-auto max-w-3xl" data-id="element-175" data-mp="s6bd7i1igls8">
        <SectionTitle data-id="element-176" data-mp="s736unbjs9fv">⏱️ Moins de préparation. Plus de ressources prêtes à utiliser.</SectionTitle>

        <ul className="mt-4 grid grid-cols-1 gap-1.5 sm:grid-cols-2" data-id="element-177" data-mp="n5dvf6kextr9">
          {readyItems.map(item => <li key={item} className="rounded bg-brand-ivory px-3 py-2 text-[12.5px] font-semibold leading-snug text-brand-brown sm:text-[13.5px]" data-id="element-178" data-mp="121v3noxb2s9l">
              {item}
            </li>)}
        </ul>

        <p className="mt-4 text-center font-serif text-lg font-bold uppercase tracking-wide text-brand-sage sm:text-xl" data-id="element-179" data-mp="16ufy8so1d9e6">
          Ouvrez le système. Choisissez votre objectif. Structurez votre séance.
          Enseignez.
        </p>
      </div>
    </section>;
}